import React, { useEffect, useState } from "react"

import { handleize } from "@utility/strings";
import { getLuminance } from "@utility/misc"

export default ({productHandle, title, values, setValue, index}) => {

  const [swatchConfig, setSwatchConfig] = useState({});

  useEffect(() => {
    var jsonString = document.getElementById("ColorSwatchSettings")?.innerHTML;
    try{
      setSwatchConfig(JSON.parse(jsonString));
    }catch(e){
      console.log("Could not load color swatch settings", e);
    }
  }, [])

  const name = handleize(title);
  const currentValue = values.find((value) => {
    return value.selected;
  })
  const optionNodes = values.map(({value, selected}, valueIndex) => <Option key={`option-${valueIndex}`} id={`option_${productHandle}_${name}_${valueIndex}`} name={name} value={value} swatchConfig={swatchConfig} checked={selected} onChange={setValue(index)} />);

  return <fieldset className="variant-picker__option no-js:hidden">
            <div className="variant-picker__option-info">
              <div className="h-stack gap-2 items-baseline">
                <legend className="text-subdued">Select {title}:</legend>
                { currentValue ? <variant-option-value form={`form_${productHandle}_${name}`} htmlFor={name}>{currentValue.value}</variant-option-value> : null }
              </div>
            </div>
            <div>
              <div data-option-selector="" className="variant-picker__option-values wrap gap-2">
                {optionNodes}
              </div>
          </div>
        </fieldset>
}


const Option = ({id, name, value, swatchConfig = {}, type, checked, onChange}) => {

  let labelClass = "block-swatch", style = {}, spanClass;
  if(type == "color" || name.indexOf("color") > -1){
    labelClass = "color-swatch rounded-full",
    spanClass = "sr-only";
    const valueDowncase = value.toLowerCase();
    if(swatchConfig[valueDowncase]){
      if(swatchConfig[valueDowncase].indexOf("#") > -1){
        const luminance = getLuminance(swatchConfig[valueDowncase]);
        if(luminance > .9){
          labelClass += " border";
        }
      }
      style["--swatch-background"] = swatchConfig[valueDowncase];
    }else{
      style["--swatch-background"] = valueDowncase
    }
  }

  return <>
          <input className="sr-only" type="radio" name={name} id={`swatch-${id}`} value={value} checked={checked} onChange={()=>{onChange(value)}} />
          <label className={labelClass} htmlFor={`swatch-${id}`} style={style}>
            <span className={spanClass}>{value}</span>
          </label>
        </>

}
